export default __webpack_public_path__ + "static/media/5.b87b4a92.svg";